import { useEffect } from 'react';

const TokenManager = () => {
  // Function to redirect to login page
  const redirectToLogin = () => {
    // Check if we're already on the login page to prevent redirect loops
    const currentPath = window.location.pathname;
    if (currentPath === '/login') {
      console.log('Already on login page, skipping redirect');
      return;
    }
    
    console.log('No token found. Redirecting to login...');
    window.location.href = '/login'; // Change this to your login page URL
  };

  useEffect(() => {
    // Function to extract token from URL
    const extractTokenFromUrl = () => {
      const url = window.location.href;
      const tokenMatch = url.match(/[?&]token=([^&]*)/);
      return tokenMatch ? tokenMatch[1] : null;
    };

    // Check if token exists in session storage
    const storedToken = sessionStorage.getItem('authToken');
    
    if (!storedToken) {
      const urlToken = extractTokenFromUrl();
      
      if (urlToken) {
        // Store token in session storage
        sessionStorage.setItem('authToken', urlToken);
        console.log('Token extracted from URL and stored in session storage');
      } else {
        // No token in storage or URL, redirect to login
        redirectToLogin();
      }
    } else {
      console.log('Token already exists in session storage');
    }
  }, []); // Empty dependency array means this runs once on mount

  // Add listener for URL changes
  useEffect(() => {
    // Handler function for URL changes
    const handleUrlChange = () => {
      const token = sessionStorage.getItem('authToken');
      const urlToken = extractTokenFromUrl();
      
      // Only update if there's a new token in the URL that's different
      if (urlToken && (!token || token !== urlToken)) {
        sessionStorage.setItem('authToken', urlToken);
        console.log('Token updated from URL');
      } else if (!token && !urlToken) {
        // No token in storage or URL after navigation, redirect to login
        redirectToLogin();
      }
    };

    // Function to extract token from current URL
    const extractTokenFromUrl = () => {
      const url = window.location.href;
      const tokenMatch = url.match(/[?&]token=([^&]*)/);
      return tokenMatch ? tokenMatch[1] : null;
    };

    // Listen for popstate events (back/forward navigation)
    window.addEventListener('popstate', handleUrlChange);
    
    // Custom event listener for programmatic navigation
    window.addEventListener('locationchange', handleUrlChange);
    
    // Create a proxy for pushState and replaceState
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;
    
    window.history.pushState = function() {
      originalPushState.apply(this, arguments);
      window.dispatchEvent(new Event('locationchange'));
    };
    
    window.history.replaceState = function() {
      originalReplaceState.apply(this, arguments);
      window.dispatchEvent(new Event('locationchange'));
    };
    
    return () => {
      // Clean up event listeners
      window.removeEventListener('popstate', handleUrlChange);
      window.removeEventListener('locationchange', handleUrlChange);
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, []);

  // This component doesn't render anything visible
  return null;
};

export default TokenManager;